module.exports = __webpack_public_path__ + "img/widget_beauty.536bb0e4.svg";